/* eslint-disable import/no-extraneous-dependencies */

import React from 'react';

import Admin from 'hive-admin';

import { getI18nFields } from '../../../helpers/i18n';
import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotProducts = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'PRODUCTS',
]);

const isNotModeManual = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'mode',
  (value) => value && value !== 'manual',
]);

const isNotModeQuery = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'mode',
  (value) => !value || value !== 'query',
]);

export default [
  ...[
    getFilterWithCol(['FieldRadio', {
      name: 'products_mode',
      label: null,
      choices: [
        { value: 'grid', label: 'Grid' },
        { value: 'slider', label: 'Slider' },
      ],
      initialValue: 'grid',
      block: true,
      prepareValueForForm: (value, props) => {
        if (value !== props.value) {
          props.form.setFieldsValue({
            products_limit: value === 'slider' ? 20 : 12,
            products_gap: value === 'slider' ? '$s' : '$xs $s',
          });
        }
        return value;
      },
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'products_limit',
      label: null,
      type: 'number',
      prefix: 'Max Items:',
      align: 'right',
      getInitialValue: (field, { form, data }) => {
        if (Number.isFinite(data?.products_limit)) {
          return data.products_limit;
        }
        const mode = form.getFieldValue('mode') || 'grid';
        return mode === 'horizontal' ? 20 : 12;
      },
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'products_minItemsWidth',
      label: null,
      prefix: 'Min items width:',
      initialValue: '240px',
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'products_gap',
      label: null,
      prefix: 'Gap:',
      initialValue: '$xs $s',
    }], 12),
    ['FieldSortableList', {
      label: (<span />),
      name: 'products_choices',
      condensed: true,
      getItemFields: getI18nFields,
      collapseFieldName: '__visible',
      collapseLabelDefault: 'Tab',
      collapseLabelFieldName: 'label',
      shouldRenderPlaceholder: true,
      fields: [
        getFilterWithCol(['FieldText', {
          name: 'label',
          label: null,
          prefix: 'Label:',
          initialValue: 'All',
          i18nTranslatable: true,
        }], 12),
        getFilterWithCol(['FieldText', {
          name: 'htmlId',
          label: null,
          prefix: 'ID:',
        }], 12),
        getFilterWithCol(['FieldRadio', {
          name: 'mode',
          label: null,
          choices: [
            { value: 'manual', label: 'Manual' },
            { value: 'query', label: 'Query' },
          ],
          initialValue: 'manual',
          block: true,
          prepareValueForForm: (value, props) => {
            if (value !== props.value && value === 'query') {
              props.form.setFieldsValue({
                products: [],
              });
            }
            return value;
          },
        }], 24),
        getFilterWithCol(['FieldSortableList', {
          name: 'products',
          label: null,
          addButtonLabel: 'Add Product',
          shouldRenderPlaceholder: true,
          skip: [
            isNotModeManual,
          ],
          head: 'horizontal',
          condensed: true,
          fields: [
            ['FieldConnectionSelect', {
              name: 'product',
              label: null,
              url: '/products',
              placeholder: 'Product',
              getExtraQueryConditions: (props) => [{
                store: (
                  props.forms[props.forms?.length - 1]?.getFieldValue('store')
                  || props?.viewer?.store
                ),
              }],
              searchPaths: ['name'],
            }],
          ],
        }], 24),
        getFilterWithCol(['FieldRadio', {
          name: 'featuredOnSale',
          label: null,
          initialValue: null,
          choices: [
            { value: null, label: 'All' },
            { value: 'ON_SALE', label: 'On Sale Only' },
            { value: 'FEATURED', label: 'Featured Only' },
            { value: 'FEATURED_ON_SALE', label: 'Featured And On Sale' },
          ],
          skip: [
            isNotModeQuery,
          ],
          block: true,
        }], 24),
        getFilterWithCol(['FieldConnectionSelect', {
          name: 'categories',
          label: null,
          prefix: 'Categories:',
          mode: 'multiple',
          url: '/categories',
          getExtraQueryConditions: (props) => [{
            store: (
              props.forms[props.forms?.length - 1]?.getFieldValue('store')
              || props?.viewer?.store
            ),
          }],
          searchPaths: ['name'],
          skip: [
            isNotModeQuery,
          ],
          handleChange: (value, props) => {
            if (value !== props.value) {
              props.form.setFieldsValue({
                subcategories: [],
              });
            }
          },
        }], 24),
        getFilterWithCol(['FieldConnectionSelect', {
          label: null,
          name: 'subcategories',
          prefix: 'Subcategories:',
          url: '/categories/:id/subcategories',
          mode: 'multiple',
          // getExtraQueryConditions: (props) => {
          //   if (!props.viewer) {
          //     return [];
          //   }
          //   if (props.viewer.role === 'SELLER') {
          //     return [{ store: props.viewer.store }];
          //   }
          //   const store = props.form.getFieldValue('store');
          //   return store
          //   ? [{ store }]
          //   : [{ name: '______________' }];
          // },
          extractChoicesQuery: (search, props) => {
            const categories = props.form.getFieldValue('categories');
            return {
              id: categories?.length === 1 ? categories[0] : '__no_id__',
              search,
            };
          },
          extractValueQuery: (value, props) => {
            const categories = props.form.getFieldValue('categories');
            return {
              id: categories?.length === 1 ? categories[0] : '__no_id__',
              subcategoryIds: Array.isArray(value) ? value : [value],
            };
          },
          searchPaths: ['name'],
          disabled: [
            Admin.compileFromLibrary([
              'condition.testFieldValue',
              'categories',
              (value) => !value || value?.length !== 1,
            ]),
          ],
          virtual: [
            Admin.compileFromLibrary([
              'condition.testFieldValue',
              'categories',
              (value) => !value || value?.length !== 1,
            ]),
          ],
          hidden: [
            Admin.compileFromLibrary([
              'condition.testFieldValue',
              'categories',
              (value) => !value || value?.length !== 1,
            ]),
          ],
        }], 24),
        getFilterWithCol(['FieldConnectionSelect', {
          name: 'collections',
          label: null,
          prefix: 'Collections:',
          mode: 'multiple',
          url: '/collections',
          getExtraQueryConditions: (props) => [{
            store: (
              props.forms[props.forms?.length - 1]?.getFieldValue('store')
              || props?.viewer?.store
            ),
          }],
          searchPaths: ['name'],
          skip: [
            isNotModeQuery,
          ],
        }], 24),
        getFilterWithCol(['FieldSelect', {
          name: 'sort',
          label: null,
          prefix: 'Sort By:',
          initialValue: 'date',
          choices: [
            { value: 'date', label: 'Latest' },
            { value: 'category', label: 'Category' },
            { value: 'price-asc', label: 'Price Asc.' },
            { value: 'price-desc', label: 'Price Desc.' },
          ],
          skip: [
            isNotModeQuery,
          ],
          block: true,
        }], 24),
      ],
    }],
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotProducts, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
